import "../../config/globalConstants.js";
import { showError as e, showSuccess as t } from "../../services/alert/alert.js";
import "../../services/index.js";
import { copyToClipboard as n } from "../../utils/copyToClipboard.js";
import { TestAnchors as r } from "./test.js";
import { Button as i } from "@jetbrains/ring-ui-built/components/button/button";
import { jsx as a } from "react/jsx-runtime";
import o from "@jetbrains/ring-ui-built/components/tooltip/tooltip";
import s from "@jetbrains/icons/copy.js";
//#region src/components/CopyButton/CopyButton.tsx
var c = 2e3, l = "Copied", u = "Couldn't copy. Please try again.", d = (d) => {
	let { textToCopy: f, showTooltip: p = !0, tooltip: m = {}, children: h, iconClassName: g, className: _, containerClassName: v, onCopy: y, showCopyIcon: b = !0, alertSuccessText: x = l, ...S } = d, C = async (t) => {
		if (t) try {
			return await n(t), y?.(), !0;
		} catch {
			return e(u), !1;
		}
		else return e(u), !1;
	}, w = async (e) => {
		e.stopPropagation(), await C(f) && t(x, c);
	}, T = async (e) => {
		(e.key === "Enter" || e.key === " ") && (e.preventDefault(), await w(e));
	};
	return /* @__PURE__ */ a(o, {
		...m,
		delay: 800,
		title: p ? m?.title ?? "Copy" : void 0,
		className: v,
		children: /* @__PURE__ */ a(i, {
			"aria-label": "Copy button",
			"data-test": r.copyButton,
			onClick: w,
			onKeyDown: T,
			inline: !0,
			className: _,
			icon: b ? s : void 0,
			iconClassName: g,
			...S,
			children: h
		})
	});
};
//#endregion
export { d as CopyButton };
